module.exports = __webpack_public_path__ + "img/icon16-call-out-success.799f35d9.svg";